import { RouteObject } from "react-router";
import Login from "../../Login/Login";
import { InfoPage } from "../../InfoPage/InfoPage";
import { RouteHandle } from "./routes";
import { OrganizationList } from "../../OrganizationList/OrganizationList";
import { OrganizationLayout } from "../../OrganizationLayout/OrganizationLayout";
import { CertificatesPage } from "../../Certificate/CertificatesPage";
import { NewCertificatePage } from "../../NewCertificate/NewCertificatePage";
import { CertificatePage } from "../../Certificate/CertificatePage";
import {
  certificateAction,
  certificateLoader,
  certificatesListLoader,
  createCertificateAction,
} from "../../Certificate/certificatesRouteContext";
import { ClientsPage } from "../../Client/ClientsPage";
import { NewClientPage } from "../../Client/NewClientPage";
import { ClientPage } from "../../Client/ClientPage";
import { EditClientPage } from "../../Client/EditClientPage";
import {
  CLIENTS_ROUTE_ID,
  clientLoader,
  clientsLoader,
  clientsMiddleware,
  createClientAction,
  deleteClientAction,
  editClientLoader,
  newClientLoader,
  updateClientAction,
} from "../../Client/clientsRouteContext";
import { AuditLogPage } from "../../AuditLog/AuditLogPage";
import { auditLogLoader } from "../../AuditLog/auditLogRouteContext";
import { UsersPage } from "../../User/UsersPage";
import { usersAction, usersLoader } from "../../User/usersRouteContext";
import { requireLoginMiddleware } from "../entrypoint/EntrypointContext";
import {
  ORGANIZATION_ROUTE_ID,
  organizationLoader,
  organizationMiddleware,
  organizationsLoader,
  PROTECTED_ROUTE_ID,
} from "../organization/OrganizationContext";
import ErrorPage from "../../ErrorPage/ErrorPage";
import { HomePage } from "../../Home/HomePage";
import { homeLoader } from "../../Home/homeRouteContext";

function titleHandle(title: string): { handle: RouteHandle } {
  return { handle: { title } };
}

const appRoutes: RouteObject[] = [
  {
    path: "info",
    element: <InfoPage />,
    ...titleHandle("Bli kunde"),
  },
  {
    path: "login",
    element: <Login />,
    ...titleHandle("Innlogging"),
  },
  {
    id: PROTECTED_ROUTE_ID,
    middleware: [requireLoginMiddleware],
    loader: organizationsLoader,
    children: [
      {
        index: true,
        element: <OrganizationList />,
        ...titleHandle("Velg virksomhet"),
      },
      {
        path: "organization/:orgnr",
        id: ORGANIZATION_ROUTE_ID,
        middleware: [organizationMiddleware],
        loader: organizationLoader,
        errorElement: <ErrorPage />,
        element: <OrganizationLayout />,
        children: [
          {
            index: true,
            element: <HomePage />,
            loader: homeLoader,
            ...titleHandle("Oversikt"),
          },
          {
            path: "certificates",
            children: [
              {
                index: true,
                element: <CertificatesPage />,
                loader: certificatesListLoader,
                ...titleHandle("Sertifikater"),
              },
              {
                path: "new",
                element: <NewCertificatePage />,
                action: createCertificateAction,
                ...titleHandle("Nytt sertifikat"),
              },
              {
                path: ":certificateId",
                element: <CertificatePage />,
                loader: certificateLoader,
                action: certificateAction,
                ...titleHandle("Sertifikat"),
              },
            ],
          },
          {
            path: "auditlog",
            element: <AuditLogPage />,
            loader: auditLogLoader,
            ...titleHandle("Aktivitetslogg"),
          },
          {
            path: "users",
            element: <UsersPage />,
            loader: usersLoader,
            action: usersAction,
            ...titleHandle("Brukere"),
          },
          {
            path: "clients",
            id: CLIENTS_ROUTE_ID,
            middleware: [clientsMiddleware],
            loader: clientsLoader,
            children: [
              {
                index: true,
                element: <ClientsPage />,
                ...titleHandle("Klienter"),
              },
              {
                path: "new",
                element: <NewClientPage />,
                loader: newClientLoader,
                action: createClientAction,
                ...titleHandle("Ny klient"),
              },
              {
                path: ":clientId",
                element: <ClientPage />,
                loader: clientLoader,
                action: deleteClientAction,
                ...titleHandle("Klient"),
              },
              {
                path: ":clientId/edit",
                element: <EditClientPage />,
                loader: editClientLoader,
                action: updateClientAction,
                ...titleHandle("Rediger klient"),
              },
            ],
          },
        ],
      },
    ],
  },
];

export default appRoutes;
